var getAppNameFromAppString = function (appName) {
    var _a;
    if (appName === void 0) { appName = ''; }
    return (_a = appName === null || appName === void 0 ? void 0 : appName.split('/')) === null || _a === void 0 ? void 0 : _a[0];
};
export default getAppNameFromAppString;
//# sourceMappingURL=getAppNameFromAppString.js.mapvar getAppNameFromAppString = function (appName) {
    var _a;
    if (appName === void 0) { appName = ''; }
    return (_a = appName === null || appName === void 0 ? void 0 : appName.split('/')) === null || _a === void 0 ? void 0 : _a[0];
};
export default getAppNameFromAppString;
//# sourceMappingURL=getAppNameFromAppString.js.map